<template>
    <div class="wrap">
        <div class="content">
            <base-header :name="user_name" :topOnly="flag_top" :account_list="account_list"></base-header>
            <div class="part1">
                <div class="noticeC">
					<p class="scrollC" v-show="noticeList.length>0">
						<span class="notice" v-for="item in noticeList">
							恭喜 {{item.user_name}} 抽中了 <span>{{item.amount}}</span> 酒豆
						</span>
					</p>
				</div>
                <LuckyWheel ref="myLucky" class="myLucky-box" :width="width" :height="height" :prizes="prizes"
                    :blocks="blocks" :buttons="buttons" @start="startCallback" @end="endCallback" />
                <div :class="[
                    'lucky-btn',
                    hascj == 2 ? 'over' : hascj == 1 ? 'loading' : '',
                ]" @click="startCallback()"></div>
            </div>
            <div class="mate-info"></div>
        </div>
        <div class="sm" v-if="pop_show == 4">
            <p>请在网页个人中心完成实名认证后参与活动</p>
            <div class="btn">
                <div class="qd" @click="pop_show = 0"></div>
            </div>
        </div>
        <div class="mark" v-if="pop_show"></div>
    </div>
</template>
<script>
import { baseUrls } from "@/utils/baseUrlConfig";
const base_url = baseUrls.user_url;
const hd_url = "https://hd.09game.com/week/";

export default {
    name: "winter",
    data() {
        return {
            token: this.$storage.getToken(),
            user_name: "",
            flag_top: true,
            account_list: [],
            pop_show: 0, //打开弹框的类型
            btn_lock: false, //防抖
            width: "7.5rem",
            height: "7.5rem",
            blocks: [],
            prizes: [],
            buttons: [],
            hascj: 0, //是否抽奖成功
            resMsg: "", //抽奖结果
            timer: null, //提示框定时器
            noticeList: [], //公告列表
        };
    },
    mounted() {
        this.requireToken();
    },
    // beforeRouteEnter(to, from, next) {
    //     next((vm) => {
    //         if (vm.$common.checkToken(vm.token)) {
    //             vm.$http.set_anchor(15, vm.token);
    //         }
    //     });
    // },
    methods: {
        requireToken() {
            var Ucookie = this.token;
            if (Ucookie != null) {
                var now = new Date().getTime();
                if (now >= Ucookie.split("-")[3] * 1000) {
                    //token过期
                    this.get_auth();
                } else {
                    this.init();
                }
            } else {
                this.get_auth();
            }
        },
        init() {
            this.token = this.$storage.getToken()
            this.query_user_baseInfo();
            this.getUserInfo();
            this.getBasicInfo();
            this.init_plate();
        },
        // 获取用户基础信息（是否为plus，以及plus的剩余天数）
        query_user_baseInfo() {
            $.ajax({
                url:"https://users.09game.com/home/GetUserPub?user_id=" + this.token.split("-")[0],
                async: false,
                success: (res) => {
                    if (res.result == 0) {
                        var u = res.temp[0];
                        this.user_name = u.user_name;
                        this.$storage.setUserId(u.user_id);
                        this.$storage.setUserName(u.user_name);
                        if (u.flag & 1024) {
                            this.plus_flag = 1; //是PLUS会员
                        } else {
                            this.plus_flag = 0;
                        }
                    } else {
                        console.log("获取用户信息错误，错误码：" + res.result);
                    }
                },
            });
            this.$http.getAllUser(this.token).then((res) => {
                if (res.result == 0 && res.msg && res.msg.length > 0) {
                    this.account_list = res.msg;
                    this.$storage.setAccountList(JSON.stringify(res.msg));
                } else {
                    this.account_list = [];
                }
            });
        },
        getUserInfo() {
            let _this = this;
            $.ajax({
                url: "https://users.09game.com/Home/GetUserInfoV1?token=" + this.token,
                success: function (res) {
                    if (res.result == 0 && res.temp) {
                        //未实名
                        if (
                            (res.temp.relate_flag & 8) == 8 ||
                            (res.temp.relate_flag & 32) == 32
                        ) {
                            //实名通过
                        } else {
                            //实名未通过
                            document.onmousewheel = null;
                            _this.pop_show = 4;
                        }
                    }
                },
            });
        },
        get_auth() {
            window.location.replace(base_url + "/GetWxOpenid?fromPage=weekjd");
        },
        // 初始化转盘数据
        init_plate() {
            this.blocks = [
                {
                    // padding: '0.46rem',
                    imgs: [
                        {
                            src: require("@/assets/img/weekjd/zpbg.png"),
                            width: this.width,
                            height: this.height,
                            rotate: true,
                        },
                    ],
                },
            ];

            const prizes = [{}, {}, {}, {}, {}, {}];
            this.prizes = prizes;
            this.buttons = [
                {
                    radius: "0%",
                    imgs: [
                        {
                            src: require("@/assets/img/weekjd/zpborder.png"),
                            top: "-3.75rem",
                            width: "7.5rem",
                            height: "7.5rem",
                        },
                    ],
                },
            ];
        },
        //获取任务基本信息
        getBasicInfo() {
            $.ajax({
                url: hd_url + "/GetWeekLottery?token=" + this.token,
                success: (res) => {
                    if (res.code == 0) {
                        this.hascj = res.info ? 2 : 0;
                        this.noticeList = res.list || [];
                    }
                },
            });
        },
        // 开启轮盘抽奖
        startCallback() {
            let element = ".wrap .content .part1 .lucky-btn";
            if (this.btn_clock) {
                return false;
            }
            if (this.hascj) {
                return;
            }
            this.btn_clock = 1;
            // 调用抽奖组件的play方法开始游戏
            $.ajax({
                url: hd_url + "/SendWeekLottery?token=" + this.token,
                success: (res) => {
                    if (res.code == 0) {
                        this.$refs.myLucky.play();
                        this.$refs.myLucky.stop(parseInt(res.rand));
                        this.resMsg = res.msg ? res.msg : "";
                        this.hascj = 1;
                        this.btn_clock = 0;
                    } else {
                        this.btn_clock = 0;
                        this.mate_show(element, res.msg ? res.msg : "操作失败，请联系管理员",-50,5 );
                    }
                },
            });
        },
        endCallback() {
            this.btn_clock = 0;
            let element = ".wrap .content .part1 .lucky-btn";
            this.mate_show(element, this.resMsg, -50, 5);
            this.hascj = 2;
            this.getBasicInfo();
        },
        mate_show(element, text, offsetTop, offsetLeft = 5) {
            $(".mate-info").html(text);
            var width1 = $(element).width();
            var width = $(".mate-info").width() + 44;
            var offWidth = (width1 - width) / 2;
            var top = $(".content").offset().top;
            var cssTop = $(element).offset().top - top + offsetTop;
            var cssLeft = $(element).offset().left + offWidth + offsetLeft;
            var css = {
                top: cssTop,
                left: cssLeft,
            };
            if (this.timer) {
                clearTimeout(this.timer);
            }
            $(".mate-info").show().css(css);
            this.timer = setTimeout(function () {
                $(".mate-info").hide().html("");
            }, 3000);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/weekjd/index.scss";
</style>



// WEBPACK FOOTER //
// src/view/weekjd.vue